// Extracts the 11-char video id from any common YouTube URL shape.
export const youtubeId = (url) => {
  const m = String(url || "").match(
    /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/|v\/))([A-Za-z0-9_-]{11})/
  );
  return m ? m[1] : null;
};
